import React, { useRef, useState, useEffect } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";
import jwt_decode from "jwt-decode";
// Re-compile trigger update
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { Link, useNavigate, useLocation } from "react-router-dom";
import Form from "../../../components/common/Form";
import FeedbackFlow from "../Feedback";
import EducationSection from "../../../components/personalDetails/EducationSection";
import PersonalDetailsSection from "../../../components/personalDetails/PersonalDetailsSection";
import ProfessionalDetails from "../../../components/personalDetails/ProfessionalDetails";
import WorkSection from "../../../components/personalDetails/WorkSection";
import {
  GET_OTHER_SUBJECT,
  GET_PROFILE_DETAILS,
  SAVE_SUBJECT_STATUS,
} from "../../../store/actions/profileActions";
import {
  getOtherSpecialization,
  getProfileDetails,
  getSubjectSpecialization,
  UploadMedia,
  getJournalsByType,
} from "../../../store/apiCalls/profileDetails";
import {
  FetchProfileDetails,
  RemoveProfile,
  SelectSpecialization,
  UpdateProfile,
  setUpProfile,
} from "./queries";
import { PATH } from "../../../routes/path";
import InfoAlert from "../../../components/common/InfoAlert";
import StateJson from "../../../constants/States.json";
import {
  affiliationFields,
  isPublishable,
  validatePhoneNumber,
  unPublishToolTip,
  getUnique,
  getJournalDisciplineName,
} from "../../../utils";
import SuccessModal from "../../../components/Modal/sucessModal";
import { SET_LOGIN_USER_SUCCESS } from "../../../store/actions/loginActions";
import CommonTab from "../../../components/common/CommonTab";
import SubjectOfIntrestSection from "../../../components/personalDetails/SubjectOfIntrestSection";
import Button from "../../../components/common/Button";
import FormModal from "../../../components/Modal/formModal";
import LightButton from "../../../components/common/Light_button";
import LeftArrow from "../../../svg/LeftArrow.svg";
import alertCheck from "../../../svg/alertCheck.svg";
import AakashgangaHome from "../../../svg/aakashgangaHome.svg";
import VikramshilaHome from "../../../svg/vikramshilaHome.svg";
import PersonalStepIcon from "../../../svg/PersonalStepIcon.png";
import ProfessionalStepIcon from "../../../svg/ProfessionalStepIcon.png";
import FinishedStepIcon from "../../../svg/FinishedStepIcon.png";
import "./PersonalDetails.scss";
import { setUpProfileDetails } from "../../../store/apiCalls/profileDetails";
import UpArrowQuestion from "../../../components/UpArrowQuestion/UpArrowQuestion";
import BeforePublishModal from "../../../components/Modal/BeforePublishModal";
import SubmitArticleModal from "../../../components/Modal/SubmitArticleModal";

const initialState = {
  showFeedbackModal: false,
  skipModal: false,
  congratsModal: false,
  referModal: false,
  congratsPreview: false,
};

const affiliationSchema = Yup.array().of(
  Yup.object().shape({
    affiliatedDepartment: Yup.string().required(),
    city: Yup.string().required(),
    pincode: Yup.string().required(),
    state: Yup.string().required(),
    subject: Yup.string().required(),
    universitySchoolCompany: Yup.string().required(),
  })
);

const educationSchema = Yup.object().shape({
  subject: Yup.string().required(),
  specialization: Yup.array().min(1),
  qualification: Yup.string().required(),
});

const subjectSchema = Yup.array().of(
  Yup.object().shape({
    subject: Yup.string().required(),
    specialization: Yup.array().min(1),
  })
);

function PersonalDetails() {
  const queryClient = useQueryClient();
  const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
  const saveStatus = useSelector((state) => state?.ProfileReducer?.saveStatus);
  const [showAccept, setShowAccept] = useState(false);
  const [profileDetails, setProfileDetails] = useState({});
  const [showFeedbackModal, setShowFeedbackModal] = useState(initialState);
  const [phone, setPhone] = useState("");
  const [webcamImage, setWebcamImage] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [openWebcam, setOpenWebcam] = useState(false);
  const [profile, setProfile] = useState("");
  const [uploadedImage, setUploadedImage] = useState("");
  const [openProfilePage, setOpenprofilePage] = useState(false);
  const [openImageUpload, setOpenImageUpload] = useState(false);
  const [showDoLatterModal, setShowDoLatterModal] = useState(false);
  const [showBackMoveModal, setShowBackMoveModal] = useState(false);
  const [anotherSpecs, setAnotherSpecs] = useState(false);
  const [specializationsData, setSpecializationsData] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [allSpecializationsData, setAllSpecializationsData] = useState([]);
  const [submitterName, setSubmitterName] = useState("");
  const [specializationStateName, setSpecializationStateName] = useState({
    name: "",
    index: null,
  });
  const [openConfermationModal, setOpenConfermationModal] = useState(false);
  const [uploadArticle, setUploadArticle] = useState(false);
  const [openRemoveImage, setOpenRemoveImage] = useState(false);
  const [saveMyWorkModal, setSaveMyWorkModal] = useState(false);
  const [journalsList, setJournalsList] = useState([]);
  const masterData = useSelector((state) => state?.MasterDataReducer);
  const [workSection, setWorkSection] = useState([
    {
      heading: "Primary Affiliation",
      affiliationType: "",
      URL: "",
      subject: "",
      specialization: [],
      allSpecializationsData: [],
      universitySchoolCompany: "",
      affiliatedDepartment: "",
      city: "",
      state: "",
      pincode: "",
      error: "",
    },
  ]);
  const [subjectOfIntrestSection, setSubjectOfIntrestSection] = useState([
    {
      subject: "",
      specialization: [],
      allSpecializationsData: [],
    },
  ]);
  const [educationSection, setEducationSection] = useState({
    qualification: "",
    subject: "",
    specialization: [],
    allSpecializationsData: [],
  });
  const [formError, setFormError] = useState({});
  const [validationError, setValidationError] = useState({
    affiliation: {},
  });
  const hiddenFileInput = useRef();
  const webcamRef = React.useRef(null);
  const capture = React.useCallback(() => {
    const pictureSrc = webcamRef.current.getScreenshot();
    setUploadedImage("");
    setWebcamImage(pictureSrc);
  }, []);

  const handleWebcam = () => {
    setWebcamImage("");
    setUploadedImage("");
    setOpenWebcam(!openWebcam);
  };

  const profileSavedData = useSelector((state) => state.ProfileReducer.user);
  const servicePercentage =
    profileSavedData?.affiliation?.affiliations?.length > 0 &&
      profileSavedData.workType &&
      profileSavedData.Education?.qualification?._id
      ? "80"
      : "30";
  const dispatch = useDispatch();
  const isSetupProfile = useSelector(
    (state) => state?.LoginReducer?.user?.publishProfile ?? null
  );

  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    location?.state?.activeTab || location?.state?.tab || "personal"
  );
  const navigate = useNavigate();
  useEffect(() => {
    setOpenprofilePage(isSetupProfile);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setAllSpecializationsData([
      ...allSpecializationsData,
      ...specializationsData,
    ]);
    // eslint-disable-next-line
  }, [specializationsData]);

  const setFocusToTextBox = () => {
    const elmnt = document.getElementsByClassName("errored")[0];
    if (elmnt) {
      var doc = document.documentElement;
      var x = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
      var y = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      const errorInput = elmnt.getElementsByTagName("input")[0];
      if (errorInput) {
        errorInput.focus();
      }
    }
  };

  const handleImageSubmit = async () => {
    const fileToUpload = imageFile || webcamImage || uploadedImage;
    if (fileToUpload) {
      const formData = new FormData();
      if (
        webcamImage &&
        typeof webcamImage === "string" &&
        webcamImage.startsWith("data:image")
      ) {
        formData.append("baseFile", webcamImage);
      } else if (imageFile) {
        formData.append("file", imageFile);
      } else if (typeof uploadedImage === "string" && uploadedImage.startsWith("data:image")) {
        formData.append("baseFile", uploadedImage);
      }

      dispatch({ type: "SET_LOADER", payload: true });
      setOpenWebcam(false);
      setOpenImageUpload(false);

      try {
        const imgResp = await UploadMedia(formData);
        const imageUrl =
          imgResp?.data?.url ||
          imgResp?.data?.data?.url ||
          (typeof imgResp?.data?.data === "string" ? imgResp?.data?.data : "") ||
          (typeof imgResp?.data === "string" ? imgResp?.data : "") ||
          imgResp?.data?.location ||
          imgResp?.data?.file ||
          imgResp?.data?.path ||
          imgResp?.data?.image ||
          "";

        const finalUrl = imageUrl || uploadedImage || webcamImage || "";
        if (finalUrl) {
          setProfile(finalUrl);
          setUploadedImage(finalUrl);
          setProfileDetails((prev) => ({
            ...prev,
            profilePicture: finalUrl,
            oldProfilePicture: finalUrl,
          }));
          localStorage.setItem("user_profilePicture", finalUrl);
          setValidationError({
            ...validationError,
            profile: false,
          });

          // Immediately save profilePicture to backend database
          const token =
            localStorage.usertoken ||
            localStorage.getItem("usertoken") ||
            "";
          let userId = user?._id;
          if (!userId && token) {
            try {
              const decoded = jwt_decode(token);
              userId = decoded?.id || decoded?._id;
            } catch (e) {}
          }
          const queryParams = {
            params: { id: userId },
            data: { profilePicture: finalUrl },
            headers: { Authorization: `Bearer ${token}` },
          };
          setUpProfileDetails(queryParams)
            .then(() => {
              queryClient.invalidateQueries("profile");
            })
            .catch((err) => console.error("Save profile pic error:", err));
        }
      } catch (err) {
        console.error("UploadMedia Error:", err);
        const fallbackUrl = uploadedImage || webcamImage || "";
        if (fallbackUrl) {
          setProfile(fallbackUrl);
          setUploadedImage(fallbackUrl);
          setProfileDetails((prev) => ({
            ...prev,
            profilePicture: fallbackUrl,
            oldProfilePicture: fallbackUrl,
          }));
          localStorage.setItem("user_profilePicture", fallbackUrl);
        }
      } finally {
        dispatch({ type: "SET_LOADER", payload: false });
      }
    }
  };

  const handleImageModalClose = () => {
    setOpenWebcam(false);
    setUploadedImage("");
    setWebcamImage("");
    setFormError({ profile: "" });
    setOpenImageUpload(false);
  };

  const handleCloseModal = () => {
    setShowBackMoveModal(false);
  };

  const handleSaveModalClose = () => {
    setSaveMyWorkModal(false);
  };

  const handleUploadImage = (event) => {
    setWebcamImage("");
    setOpenWebcam(false);
    let reader = new FileReader();
    let file = event.target.files[0];
    reader.readAsDataURL(file);
    if (file.type?.split("/")[0] === "image" && file.size < 50000000) {
      reader.onloadend = () => {
        setUploadedImage(reader.result);
        setImageFile(file);
        setFormError({ profile: "" });
      };
    } else {
      setFormError({
        ...formError,
        profile: "Image size should be less than 50kb.",
      });
    }
  };

  const addAnotherField = () => {
    if (workSection.length < 3) {
      const cloneWorkSection = [...workSection];
      cloneWorkSection.push({
        heading:
          workSection.length < 2
            ? "Secondary Affiliation"
            : "Tertiary Affiliation",
        URL: "",
        subject: "",
        specialization: [],
        allSpecializationsData: [],
        universitySchoolCompany: "",
        affiliatedDepartment: "",
        city: "",
        state: "",
        pincode: "",
        error: "",
      });
      setWorkSection(cloneWorkSection);
    }
  };
  const removeField = (order) => {
    const cloneWorkSection = [...workSection];
    const newArray = cloneWorkSection.filter(
      (element, index) => index !== order
    );
    setWorkSection(newArray);
  };

  const handleSubjectOfIntrestChange = async (e, index) => {
    const { name, value } = e.target;
    let cloneSubjectOfIntrestSection = [...subjectOfIntrestSection];
    if (name === "interestedsubject") {
      cloneSubjectOfIntrestSection[index].subject = value;
      cloneSubjectOfIntrestSection[index].specialization = [];
      const getsubject = masterData?.MasterData?.subjectdata.find(
        (item) => item.subjectName === value
      );
      setSpecializationStateName({
        name: "subjectOfIntrestSection",
        index: index,
      });
      const dataRecords = await setSpecializationsRecords(getsubject?._id);
      cloneSubjectOfIntrestSection[index].allSpecializationsData = dataRecords;
    } else if (name === "Interested Specialization") {
      if (cloneSubjectOfIntrestSection[index].specialization.includes(value)) {
        cloneSubjectOfIntrestSection[index].specialization.splice(
          cloneSubjectOfIntrestSection[index].specialization.indexOf(value),
          1
        );
      } else {
        if (cloneSubjectOfIntrestSection[index].specialization.length < 3) {
          cloneSubjectOfIntrestSection[index].specialization.push(value);
        }
      }
      setAnotherSpecs(true);
    }
    setSubjectOfIntrestSection(cloneSubjectOfIntrestSection);
  };

  const setSpecializationsRecords = async (id = "") => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      subjectId: id,
    };
    const response = await getSubjectSpecialization(headers, params);
    if (response?.status === 200) {
      setSpecializationsData(response?.data?.data?.data);
      return response?.data?.data?.data;
    } else return;
  };

  const handleSubjectId = async (id) => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      subjectId: id,
    };
    const response = await getSubjectSpecialization(headers, params);
    if (response?.status === 200) {
      let newRecord = response?.data?.data?.data;
      setSubjectOptions(
        newRecord
          ? newRecord
            ?.filter(
              (spec) =>
                spec?.specialization !==
                "Other Subject (choose this option to register your subject)"
            )
            .map((spec) => spec?.specialization)
          : []
      );
    } else return;
  };

  const handleEducationOtherSpecialization = (data = {}) => {
    const cloneEducationSection = { ...educationSection };
    cloneEducationSection.otherSpecialization =
      cloneEducationSection.otherSpecialization ?? [];
    cloneEducationSection.otherSpecialization.push(data);
    cloneEducationSection.specialization?.push(data.specialization);
    setEducationSection(cloneEducationSection);
  };

  const handleGetSpecialization = async () => {
    const headers = { Authorization: `Bearer ${localStorage.usertoken || ""}` };
    const { id } = jwt_decode(localStorage.usertoken);
    const params = {
      userId: id,
    };
    dispatch({ type: "SET_LOADER", payload: true });
    const addResp = await getOtherSpecialization(headers, params);
    dispatch({ type: "SET_LOADER", payload: false });
    if (addResp.data?.success) {
      dispatch({
        type: GET_OTHER_SUBJECT,
        payload: addResp?.data?.data,
      });
      getSubjectStatus(addResp?.data?.data);
    } else return;
  };

  const getSubjectStatus = (anotherSubject) => {
    anotherSubject &&
      anotherSubject?.filter((sub) => {
        if (sub?.status === "Pending") {
          dispatch({
            type: SAVE_SUBJECT_STATUS,
            payload: true,
          });
        }
        return;
      });
  };

  useEffect(() => {
    if (location?.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
    if (location?.state?.profileDetails) {
      sucessHandler({ data: { data: location.state.profileDetails } });
    }
    handleGetSpecialization();
    getSubjectStatus();
    fetchdata().then((res) => {
      if (res?.data) {
        sucessHandler(res);
      }
    });
  }, [location?.state]);

  useEffect(() => {
    if (profileDetails?.journalType) {
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const apiType = profileDetails.journalType === "Mega Journal" ? "mega" : "society";
      getJournalsByType(headers, { journalType: apiType }).then((res) => {
        console.log("journal", res)
        if (res?.data?.success) {
          setJournalsList(res.data.data || []);
        } else if (res?.data?.data) {
          setJournalsList(res.data.data);
        } else {
          setJournalsList([]);
        }
      });
    } else {
      setJournalsList([]);
    }
  }, [profileDetails?.journalType]);

  useEffect(() => {
    if (profileDetails?.journalName) {
      const autoDiscipline = getJournalDisciplineName(
        profileDetails.journalName,
        journalsList,
        masterData
      );
      if (autoDiscipline && workSection && workSection.length > 0) {
        if (workSection[0]?.subject !== autoDiscipline) {
          setWorkSection((prevWorkSection) => {
            if (!prevWorkSection || prevWorkSection.length === 0) return prevWorkSection;
            if (prevWorkSection[0]?.subject !== autoDiscipline) {
              const updated = [...prevWorkSection];
              updated[0] = {
                ...updated[0],
                subject: autoDiscipline,
              };
              const getsubject = masterData?.MasterData?.subjectdata?.find(
                (item) => item.subjectName === autoDiscipline
              );
              if (getsubject?._id) {
                setSpecializationStateName({ name: "workSection", index: 0 });
                setSpecializationsRecords(getsubject._id).then((records) => {
                  if (records) {
                    setWorkSection((ws) => {
                      const wsCopy = [...ws];
                      if (wsCopy[0]) {
                        wsCopy[0] = {
                          ...wsCopy[0],
                          subject: autoDiscipline,
                          allSpecializationsData: records,
                        };
                      }
                      return wsCopy;
                    });
                  }
                });
              }
              return updated;
            }
            return prevWorkSection;
          });
        }
      }
    }
  }, [profileDetails?.journalName, journalsList, masterData, workSection]);

  const workSectionOtherSpecialization = (data = {}, index) => {
    const cloneWorkSection = [...workSection];
    cloneWorkSection[index].otherSpecialization =
      cloneWorkSection[index]?.otherSpecialization ?? [];
    cloneWorkSection[index]?.otherSpecialization?.push(data);
    cloneWorkSection[index].specialization?.push(data.specialization);
    setWorkSection(cloneWorkSection);
  };

  const handleSubjectSpecialization = (data = {}, index) => {
    let cloneSubjectOfIntrestSection = [...subjectOfIntrestSection];
    cloneSubjectOfIntrestSection[index].otherSpecialization =
      cloneSubjectOfIntrestSection[index]?.otherSpecialization ?? [];
    cloneSubjectOfIntrestSection[index].otherSpecialization?.push(data);
    cloneSubjectOfIntrestSection[index].specialization?.push(
      data.specialization
    );
    setSubjectOfIntrestSection(cloneSubjectOfIntrestSection);
  };

  const handleEducationChange = async (e, type) => {
    const { name, value } = e.target;
    const cloneEducationSection = { ...educationSection };

    if (name === "specialization") {
      if (cloneEducationSection.specialization.includes(value)) {
        cloneEducationSection.specialization.splice(
          cloneEducationSection.specialization.indexOf(value),
          1
        );
      } else {
        if (cloneEducationSection.specialization.length < 3) {
          cloneEducationSection.specialization.push(value);
        }
      }
      setAnotherSpecs(true);
    } else if (name === "subject") {
      const getsubject = masterData?.MasterData?.subjectdata.find(
        (item) => item.subjectName === value
      );
      setSpecializationStateName({
        name: "educationSection",
        index: null,
      });
      const dataRecords = await setSpecializationsRecords(getsubject?._id);
      cloneEducationSection[name] = value;
      cloneEducationSection.allSpecializationsData = dataRecords;
    } else {
      cloneEducationSection[name] = value;
    }
    setEducationSection(cloneEducationSection);

    setValidationError({
      ...validationError,
      educationError: { ...validationError?.educationError, [name]: false },
    });
  };

  const handleSubjectSelectChange = async (value, name, index) => {
    let cloneSubjectOfIntrestSection = [...subjectOfIntrestSection];
    if (name === "interestedsubject") {
      cloneSubjectOfIntrestSection[index].subject = value;
      cloneSubjectOfIntrestSection[index].specialization = [];
      const getsubject = masterData?.MasterData?.subjectdata.find(
        (item) => item.subjectName === value
      );
      setSpecializationStateName({
        name: "subjectOfIntrestSection",
        index: index,
      });
      const dataRecords = await setSpecializationsRecords(getsubject?._id);
      cloneSubjectOfIntrestSection[index].allSpecializationsData = dataRecords;
    }
    setSubjectOfIntrestSection(cloneSubjectOfIntrestSection);
  };

  const handleEducationSelectChange = async (value, name) => {
    const cloneEducationSection = { ...educationSection };
    if (name === "subject") {
      const getsubject = masterData?.MasterData?.subjectdata.find(
        (item) => item.subjectName === value
      );
      setSpecializationStateName({
        name: "educationSection",
        index: null,
      });
      const dataRecords = await setSpecializationsRecords(getsubject?._id);
      cloneEducationSection[name] = value;
      cloneEducationSection.specialization = [];
      cloneEducationSection.allSpecializationsData = dataRecords;
    } else {
      cloneEducationSection[name] = value;
    }

    setValidationError({
      ...validationError,
      educationError: { ...validationError?.educationError, [name]: false },
    });
    setEducationSection(cloneEducationSection);
  };

  const handleWorkSelectChange = (value, Sectionindex, name) => {
    var clonedError = validationError;
    const cloneWorkSection = [...workSection];
    const updateWorkSection = cloneWorkSection.map((item, ind) => {
      if (ind === Sectionindex) {
        if (clonedError["affiliation"]?.[ind]) {
          clonedError["affiliation"][ind][name] = false;
        }

        if (name === "subject") {
          const getsubject = masterData?.MasterData?.subjectdata.find(
            (item) => item.subjectName === value
          );
          setSpecializationStateName({ name: "workSection", index: ind });
          const dataRecords = setSpecializationsRecords(getsubject?._id);
          return {
            ...item,
            allSpecializationsData: dataRecords,
            [name]: value,
            specialization: [],
          };
        } else {
          return { ...item, [name]: value };
        }
      }
      return item;
    });
    setWorkSection(updateWorkSection);
    setValidationError({
      ...clonedError,
    });
  };

  const handleSelectChange = (value, type) => {
    if (type === "gender") {
      localStorage.setItem("user_gender", value);
    }
    if (type === "nationality") {
      localStorage.setItem("user_nationality", value);
    }
    if (type === "journalType") {
      localStorage.setItem("user_journalType", value);
      localStorage.setItem("user_journalName", "");
      setValidationError((prev) => ({
        ...prev,
        journalType: false,
        journalName: false,
      }));
      return setProfileDetails((prev) => ({
        ...prev,
        journalType: value,
        journalName: "",
      }));
    }
    if (type === "journalName") {
      localStorage.setItem("user_journalName", value);
    }
    setValidationError((prev) => ({
      ...prev,
      [type]: false,
    }));
    return setProfileDetails((prev) => ({ ...prev, [type]: value }));
  };

  const handleChange = (e, type) => {
    const { name, value } = e.target;

    if (type) {
      if (name === "subject") {
        const getsubject = masterData?.MasterData?.subjectdata.find(
          (item) => item.subjectName === value
        );
        setSpecializationsRecords(getsubject?._id);
      }
      return setProfileDetails({
        ...profileDetails,
        [type]: { ...profileDetails[type], [name]: value },
      });
    } else {
      if (name === "phoneNumber") {
        return setProfileDetails({
          ...profileDetails,
          [name]: validatePhoneNumber(value),
        });
      }
      return setProfileDetails({ ...profileDetails, [name]: value });
    }
  };

  const handleWorkSectionChange = (e, index) => {
    const { name, value, id } = e.target;
    const cloneWorkSection = [...workSection];

    var clonedError = validationError;
    const updateWorkSection = cloneWorkSection.map((item, ind) => {
      if (ind === index) {
        if (clonedError["affiliation"]?.[ind]) {
          clonedError["affiliation"][ind][name] = false;
        }

        if (name === "pincode") {
          return { ...item, pincode: validatePhoneNumber(value) };
        } else if (name === "affiliationType") {
          return {
            ...item,
            verified: false,
            affiliationType: id,
            city: "",
            state: "",
            specialization: [],
            subject: "",
            universitySchoolCompany: "",
            affiliatedDepartment: "",
            pincode: "",
            URL: "",
            error: "",
          };
        } else if (name === "specialization") {
          if (cloneWorkSection[index].specialization.includes(value)) {
            cloneWorkSection[index].specialization.splice(
              cloneWorkSection[index].specialization.indexOf(value),
              1
            );
          } else {
            if (cloneWorkSection[index].specialization.length < 3) {
              cloneWorkSection[index].specialization.push(value);
            }
          }
          setAnotherSpecs(true);
        } else if (name === "subject") {
          const getsubject = masterData?.MasterData?.subjectdata.find(
            (item) => item.subjectName === value
          );
          setSpecializationStateName({ name: "workSection", index: ind });
          const dataRecords = setSpecializationsRecords(getsubject?._id);
          return {
            ...item,
            allSpecializationsData: dataRecords,
            [name]: value,
            specialization: [],
          };
        } else return { ...item, [name]: value };
      }
      return item;
    });
    setWorkSection(updateWorkSection);

    setValidationError({
      ...clonedError,
    });
  };

  const handleChangeRadioButton = (e, type) => {
    const { name, id } = e.target;
    setProfileDetails({ ...profileDetails, [name]: id });
    setValidationError({
      ...validationError,
      [name]: false,
    });
  };

  const { user, userLoginDetails } = useSelector(
    (state) => state?.LoginReducer
  );
  const renderHeading = (value) => {
    if (value?.order == 2) {
      return "Secondary Affiliation";
    } else if (value?.order == 3) {
      return "Tertiary Affiliation";
    }
    return null;
  };
  const sucessHandler = (fetchedData) => {
    let resData = fetchedData?.data?.data;
    dispatch({
      type: GET_PROFILE_DETAILS,
      payload: fetchedData?.data,
    });
    const payload = fetchedData?.data;
    const newPayload = { ...payload, token: localStorage.getItem("usertoken") };
    dispatch({
      type: SET_LOGIN_USER_SUCCESS,
      payload: newPayload,
    });

    if (isInitialLoaded.current) {
      // Do not overwrite user input states if initial load has already completed
      return;
    }
    setUploadedImage("");
    setWebcamImage("");
    setPhone(fetchedData?.data?.data?.phoneNumber);
    if (resData?.Education?.qualification) {
      let educationData = {
        qualification: resData?.Education?.qualification?.qualification,
        specialization: resData?.Education?.specialization?.map(
          (val) => val?.specialization
        ),
        subject: resData?.Education?.subject?.subjectName,
        allSpecializationsData: resData?.Education?.specialization,
      };
      setEducationSection(educationData);
    }

    if (resData?.subjectOfInterest?.length > 0) {
      let subOfIntData = resData?.subjectOfInterest?.map((val) => {
        return {
          specialization: val?.specialization?.map(
            (val) => val?.specialization
          ),
          subject: val?.interestedsubject?.subjectName,
          allSpecializationsData: val?.specialization,
        };
      });
      setSubjectOfIntrestSection(subOfIntData);
    }

    if (resData?.affiliation?.affiliations?.length > 0) {
      let afflicationData = resData?.affiliation?.affiliations?.map((val) => {
        return {
          heading:
            // eslint-disable-next-line
            val?.order == 1
              ? "Primary Affiliation"
              : // eslint-disable-next-line
              renderHeading(val),
          affiliationType:
            // eslint-disable-next-line
            val?.order == 1 && resData?.affiliation?.affiliation_type,
          URL: val?.url,
          verified: val?.url ? true : false,
          subject: val?.subject?.subjectName,
          specialization: val.specialization?.map((val) => val?.specialization),
          allSpecializationsData: val.specialization,
          universitySchoolCompany: val?.name,
          affiliatedDepartment: val?.department,
          city: val?.city,
          state: val?.state,
          pincode: val?.pincode === 0 ? "" : val?.pincode,
          error: "",
        };
      });
      setWorkSection(afflicationData);
    }

    const finalGender = resData?.gender || localStorage.getItem("user_gender") || "";
    const finalNationality = resData?.nationality || localStorage.getItem("user_nationality") || "";
    const finalJournalType = resData?.journalType || localStorage.getItem("user_journalType") || "";
    const finalJournalName =
      resData?.journalName ||
      resData?.journal?.journalName ||
      (typeof resData?.journal === "string" ? resData.journal : "") ||
      localStorage.getItem("user_journalName") ||
      "";

    if (finalGender) localStorage.setItem("user_gender", finalGender);
    if (finalNationality) localStorage.setItem("user_nationality", finalNationality);
    if (finalJournalType) localStorage.setItem("user_journalType", finalJournalType);
    if (finalJournalName) localStorage.setItem("user_journalName", finalJournalName);

    setProfileDetails({
      title: resData?.title,
      fullName: resData?.fullName,
      gender: finalGender,
      phoneNumber: resData?.phoneNumber,
      workType: resData?.workType,
      email: resData?.email,
      oldProfilePicture: resData?.profilePicture,
      promoCode: resData?.promoCode,
      nationality: finalNationality,
      feedbackDone: resData.feedbackDone,
      publishProfile: resData.publishProfile,
      journalType: finalJournalType,
      journalName: finalJournalName,
    });

    const finalPic = resData?.profilePicture || localStorage.getItem("user_profilePicture") || "";
    if (finalPic) localStorage.setItem("user_profilePicture", finalPic);
    setProfile(finalPic);
    setTimeout(() => {
      isInitialLoaded.current = true;
    }, 500);
  };

  const fetchdata = async () => {
    const token =
      localStorage.usertoken ||
      localStorage.getItem("usertoken") ||
      userLoginDetails?.token ||
      "";
    let userId = user?._id;
    if (!userId && token) {
      try {
        const decoded = jwt_decode(token);
        userId = decoded?.id || decoded?._id;
      } catch (e) {
        console.error(e);
      }
    }
    const params = { id: userId };
    const headers = { Authorization: `Bearer ${token}` };
    return getProfileDetails(headers, params);
  };
  const { refetch } = FetchProfileDetails(
    fetchdata,
    sucessHandler,
    setFormError,
    formError
  );
  const updedProfile = (sucess) => {
    refetch();
  };

  useEffect(() => {
    setValidationError({
      affiliation: {},
    });
  }, [activeTab]);

  useEffect(() => {
    if (
      specializationStateName.name === "workSection" &&
      typeof specializationStateName.index === "number"
    ) {
      let cloneState = [...workSection];
      cloneState[specializationStateName.index].allSpecializationsData = [
        ...specializationsData,
      ];
      setWorkSection(cloneState);
    } else if (
      specializationStateName.name === "subjectOfIntrestSection" &&
      typeof specializationStateName.index === "number"
    ) {
      let cloneState = [...subjectOfIntrestSection];
      cloneState[specializationStateName.index].allSpecializationsData = [
        ...specializationsData,
      ];
      setSubjectOfIntrestSection(cloneState);
    } else if (
      specializationStateName.name === "educationSection" &&
      specializationStateName.index === null
    ) {
      let cloneState = { ...educationSection };
      cloneState.allSpecializationsData = [...specializationsData];
      setEducationSection(cloneState);
    }
    // eslint-disable-next-line
  }, [specializationsData, anotherSpecs]);

  useEffect(() => {
    const educationSubject = masterData?.MasterData?.subjectdata?.find(
      (sub) => sub?.subjectName === educationSection?.subject
    );

    setEducationSection((es) => ({
      ...es,
      allSpecializationsData:
        masterData?.MasterData?.specializationdata?.filter(
          (item) => item.subjectId === educationSubject?._id
        ),
    }));

    setSubjectOfIntrestSection(
      subjectOfIntrestSection?.map((soi) => ({
        ...soi,
        allSpecializationsData:
          masterData?.MasterData?.specializationdata?.filter(
            (item) =>
              item?.subjectId ===
              masterData?.MasterData?.subjectdata?.find(
                (sub) => sub?.subjectName === soi?.subject
              )?._id
          ),
      }))
    );

    setWorkSection(
      workSection?.map((aff) => ({
        ...aff,
        allSpecializationsData:
          masterData?.MasterData.specializationdata?.filter(
            (item) =>
              item?.subjectId ===
              masterData?.MasterData.subjectdata?.find(
                (subject) => subject.subjectName === aff?.subject
              )?._id
          ),
      }))
    );
  }, [anotherSpecs, specializationsData]);

  const removeProfileSucess = (sucess) => {
    refetch();
  };

  const { mutate: removeProfilePic } = RemoveProfile(
    removeProfileSucess,
    setFormError,
    formError
  );

  const successHandlerUpdateProfile = (details) => {
    if (details?.status === 200) {
      const isPreview =
        submitterName === "Preview Profile" || submitterName === "PREVIEW";
      const isPublish =
        submitterName === "Publish Profile" || submitterName === "PUBLISH";

      if (isPreview) {
        const backendData = details?.data?.data || details?.data || {};
        const updatedData = {
          ...profileDetails,
          ...backendData,
          gender: profileDetails?.gender || backendData?.gender || "",
          nationality: profileDetails?.nationality || backendData?.nationality || "",
          journalType: profileDetails?.journalType || backendData?.journalType || "",
          journalName: profileDetails?.journalName || backendData?.journalName || "",
        };
        // Invalidate cache so PreviewProfile fetches fresh data from server
        queryClient.invalidateQueries('profile');
        navigate("/previewprofile", {
          state: { profileDetails: updatedData },
        });
      } else if (activeTab === "personal") {
        setActiveTab("professional");
      } else if (activeTab === "professional" || isPublish) {
        setOpenConfermationModal(true);
      }
    }
    refetch();
  };

  const { mutate: updateAuthorProfileDetails } = setUpProfile(
    successHandlerUpdateProfile,
    setFormError,
    formError
  );

  const handleDoItLatterModal = () => {
    setShowDoLatterModal(false);
    navigate("/");
  };

  const isProfilePublishable = isPublishable({
    ...profileDetails,
    profilePicture: profile,
    affiliations: workSection,
    subjects: subjectOfIntrestSection,
    educationSection: educationSection,
  });
  let SaveContinueBtn = (
    <div className="button-row-center">
      {false ? (
        <Link to="/" className="btn-save-outline" onClick={handleRedirect}>
          Home
        </Link>
      ) : (
        <>
          <Link
            id="Save"
            to="#"
            className="btn-save-outline"
            onClick={(e) => handleSubmit(e, true)}
          >
            SAVE
          </Link>
          <Button
            form="personal_details"
            id="Continue"
            title="NEXT"
            handleClick={(e) => handleSubmit(e, true, true)}
            className="btn-filled-teal"
          />
        </>
      )}
    </div>
  );

  const handleLogout = () => {
    localStorage.clear();
    dispatch({ type: "LOGOUT_STATUS_SUCCESS" });
  };

  let SaveContinueBtnFooter = (
    <div className="button-row-center">
      {false ? (
        <Link to="/" className="btn-save-outline" onClick={handleRedirect}>
          Home
        </Link>
      ) : (
        <>
          <Link
            to="#"
            id="Save"
            className="btn-save-outline"
            onClick={(e) => handleSubmit(e, true)}
          >
            SAVE
          </Link>
          <Button
            form="personal_details"
            id="Continue"
            title="NEXT"
            handleClick={(e) => handleSubmit(e, true, true)}
            className="btn-filled-teal"
          />
        </>
      )}
    </div>
  );
  const savePreviewPublishBtn = (
    <div className="button-row-center">
      {profileDetails.publishProfile ? (
        <Link to="/" className="btn-save-outline">
          Home
        </Link>
      ) : (
        <>
          <Link
            id="Save"
            to="#"
            className="btn-save-outline"
            onClick={(e) => handleSubmit(e, true)}
          >
            SAVE
          </Link>

          <Button
            form="personal_details"
            className="btn-save-outline"
            type="button"
            onClick={(e) => handleSubmit(e, true)}
            id="Preview Profile"
            title="PREVIEW"
          />
          <Button
            title="PUBLISH PROFILE"
            form="personal_details"
            placement="auto"
            toolTipMsg={isProfilePublishable ? "" : unPublishToolTip}
            type="button"
            id="Publish Profile"
            onClick={(e) => {
              profileDetails?.nationality === "outSideIndia"
                ? handleSubmitOutSideIndia(e, false)
                : handleSubmit(e, false);
            }}
            className="btn-filled-teal"
          />
        </>
      )}
    </div>
  );
  const removeAffiliationField = (index) => {
    if (workSection.length > 1) {
      const targetIndex = index !== undefined ? index : workSection.length - 1;
      const updatedWorkSection = workSection.filter((_, idx) => idx !== targetIndex);
      setWorkSection(updatedWorkSection);
    }
  };

  const renderLinks = () => {
    return (
      <div className="col-12 mt-2 text-start link-container d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div className="d-flex align-items-center gap-4">
          {workSection.length < 3 && (
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                addAnotherField();
              }}
              className="link-add-another"
            >
              + Add Another Affiliation
            </Link>
          )}
          {workSection.length > 1 && (
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                removeAffiliationField();
              }}
              className="link-remove-subject"
            >
              - Remove Affiliation
            </Link>
          )}
        </div>
        <small className="soi-limit-note">
          *You can add up to 3 affiliation
        </small>
      </div>
    );
  };
  const addAnothersubjectOfIntrestField = () => {
    setSubjectOfIntrestSection([
      ...subjectOfIntrestSection,
      {
        subject: "",
        specialization: [],
        allSpecializationsData: [],
      },
    ]);
  };
  const removesubjectOfIntrestField = () => {
    setSubjectOfIntrestSection([
      ...subjectOfIntrestSection.slice(0, subjectOfIntrestSection.length - 1),
    ]);
  };
  const renderSubjectOfIntrestLinks = () => {
    return (
      <div className="d-flex align-items-center gap-4">
        {subjectOfIntrestSection.length < 3 && (
          <Link
            to="#"
            onClick={addAnothersubjectOfIntrestField}
            className="link-add-another"
          >
            + Add Another
          </Link>
        )}
        {subjectOfIntrestSection.length > 1 && (
          <Link
            to="#"
            onClick={removesubjectOfIntrestField}
            className="link-remove-subject"
          >
            - Remove Subject
          </Link>
        )}
      </div>
    );
  };

  const personalValidation = () => {
    const fields = [
      "title",
      "email",
      "phoneNumber",
      "fullName",
      "nationality",
      "gender",
      "journalType",
      "journalName",
    ];
    const clonedError = {};
    fields.map((field) => {
      clonedError[field] = profileDetails[field] ? false : true;
      if (
        field === "phoneNumber" &&
        profileDetails.nationality === "outSideIndia"
      ) {
        clonedError[field] = false;
      }
    });
    clonedError.profile = profile ? false : true;
    setValidationError(clonedError);
    const CheckUniqueValue = { ...clonedError };
    return getUnique(Object.values(CheckUniqueValue)).length > 1 ? false : true;
  };

  const professionalValidation = async () => {
    const educationError = await educationSchema
      .validate(educationSection, {
        abortEarly: false,
      })
      .then((data) => {
        return {};
      })
      .catch((error) => {
        return error.inner.reduce((acc, error) => {
          return {
            ...acc,
            [error.path]: true,
          };
        }, {});
      });

    const clonedError = { educationError };
    clonedError.workType = profileDetails.workType ? false : true;
    clonedError.affiliation = {};
    const autoDiscipline0 = profileDetails?.journalName
      ? getJournalDisciplineName(profileDetails.journalName, journalsList, masterData)
      : "";

    workSection.map((record, index) => {
      if (index < 1 || record.universitySchoolCompany || record.URL) {
        clonedError.affiliation[index] = {};
        const effectiveSubject =
          index === 0 && autoDiscipline0
            ? record.subject || autoDiscipline0
            : record.subject;
        affiliationFields.map((field) => {
          const val = field === "subject" ? effectiveSubject : record[field];
          if (!val) {
            clonedError.affiliation[index][field] = true;
          }
        });
        if (index < 1 && !record.affiliationType) {
          clonedError.affiliation[index]["affiliationType"] = true;
        }
        if (record.specialization.length < 1) {
          clonedError.affiliation[index]["specialization"] = true;
        }

        if (!record.verified) {
          clonedError.affiliation[index]["url"] = true;
        }
      }
    });
    let finalErrors = [
      clonedError.workType,
      [Object.values(educationError), getErrors(clonedError.affiliation)],
    ].flat();
    finalErrors = getUnique(finalErrors.flat());
    setValidationError(clonedError);
    return finalErrors.length > 1 ? false : !finalErrors[0];
  };

  const getErrors = (data = {}) => {
    return Object.values(data)
      .map((a) => Object.values(a))
      .flat();
  };

  const validateSubmission = () => {
    return activeTab === "personal"
      ? personalValidation()
      : professionalValidation();
  };

  const buildFormDataPayload = (dontPublishPro = true) => {
    const affiliationData = [...workSection];
    const formdata = {};
    formdata.publishProfile = !dontPublishPro;
    formdata.isSetupProfile = !dontPublishPro;
    formdata.title = profileDetails?.title;
    formdata.email = profileDetails?.email;
    formdata.fullName = profileDetails?.fullName;
    formdata.gender = profileDetails?.gender;
    formdata.phoneNumber = profileDetails?.phoneNumber;
    formdata.workType = profileDetails?.workType;
    formdata.nationality = profileDetails?.nationality;
    if (profileDetails?.journalType) formdata.journalType = profileDetails?.journalType;
    if (profileDetails?.journalName) formdata.journalName = profileDetails?.journalName;
    if (profileDetails?.journalName) formdata.journal = profileDetails?.journalName;

    formdata.Education = {
      qualification: masterData?.MasterData?.qualificationdata?.find(
        (val) => val.qualification === educationSection?.qualification
      )?._id,
      subject: masterData?.MasterData?.subjectdata?.find(
        (val) => val.subjectName === educationSection?.subject
      )?._id,
      specialization: educationSection?.specialization
        ?.map((spl) => {
          return educationSection?.allSpecializationsData?.find(
            (val) => val?.specialization === spl
          )?._id;
        })
        .filter((spl) => spl !== undefined),
    };
    if (Array.isArray(educationSection?.otherSpecialization)) {
      formdata.Education.specialization = [
        ...(formdata.Education.specialization || []),
        ...educationSection?.otherSpecialization.map((a) => a._id),
      ];
    }
    formdata.subjectOfInterest = subjectOfIntrestSection?.map((soi) => {
      const record = {
        interestedsubject: masterData?.MasterData?.subjectdata?.find(
          (val) => val?.subjectName === soi?.subject
        )?._id,
        specialization: soi?.specialization
          ?.map((spl) => {
            return soi?.allSpecializationsData?.find(
              (val) => val.specialization === spl
            )?._id;
          })
          .filter((spl) => spl !== undefined),
      };
      if (Array.isArray(soi.otherSpecialization)) {
        record.specialization = [
          ...(record.specialization || []),
          ...soi.otherSpecialization.map((a) => a._id),
        ];
      }
      return record;
    });
    formdata.affiliation = {
      affiliation_type:
        affiliationData[0] && affiliationData[0].affiliationType,
      affiliations: affiliationData?.map((affData, ind) => {
        const autoDiscipline =
          ind === 0 && profileDetails?.journalName
            ? getJournalDisciplineName(profileDetails.journalName, journalsList, masterData)
            : "";
        const effectiveSubjectName = affData?.subject || autoDiscipline;
        const affRecord = {
          order: ind + 1,
          name: affData?.universitySchoolCompany,
          url: affData?.URL,
          department: affData?.affiliatedDepartment,
          state: affData?.state,
          city: affData?.city,
          subject: masterData?.MasterData?.subjectdata?.find(
            (val) => val?.subjectName === effectiveSubjectName
          )?._id,

          specialization: affData?.specialization
            ?.map((spl) => {
              return affData?.allSpecializationsData?.find(
                (val) => val.specialization === spl
              )?._id;
            })
            .filter((spl) => spl !== undefined),
          pincode: Number(affData?.pincode),
        };
        if (Array.isArray(affData.otherSpecialization)) {
          affRecord.specialization = [
            ...(affRecord.specialization || []),
            ...affData.otherSpecialization.map((a) => a._id),
          ];
        }
        return affRecord;
      }),
    };

    const picUrl =
      profile ||
      profileDetails?.profilePicture ||
      profileDetails?.oldProfilePicture ||
      uploadedImage ||
      localStorage.getItem("user_profilePicture") ||
      "";
    if (picUrl) {
      formdata.profilePicture = picUrl;
    }

    return formdata;
  };

  const isInitialLoaded = useRef(false);

  useEffect(() => {
    if (!isInitialLoaded.current) return;

    const timer = setTimeout(() => {
      const formdata = buildFormDataPayload(true);
      const token =
        localStorage.usertoken ||
        localStorage.getItem("usertoken") ||
        "";
      let userId = user?._id;
      if (!userId && token) {
        try {
          const decoded = jwt_decode(token);
          userId = decoded?.id || decoded?._id;
        } catch (e) {
          console.error(e);
        }
      }
      const queryParams = {
        params: { id: userId },
        data: formdata,
        headers: { Authorization: `Bearer ${token}` },
      };
      setUpProfileDetails(queryParams)
        .catch((err) => console.error("Autosave error:", err));
    }, 800);

    return () => clearTimeout(timer);
  }, [profileDetails, workSection, educationSection, subjectOfIntrestSection, profile]);

  const handleSubmit = async (event, dontPublishPro, nomodalopen) => {
    const targetElem =
      event?.target?.closest("button") ||
      event?.target?.closest("a") ||
      event?.nativeEvent?.submitter;
    const submitterId =
      targetElem?.id ||
      event?.nativeEvent?.submitter?.id ||
      event?.target?.id ||
      "";
    setSubmitterName(submitterId);
    if (saveStatus && submitterId === "Publish Profile") {
      setShowAccept(true);
    } else {
      event.preventDefault();
      window.scroll({ top: 0, behavior: "smooth" });
      const isValid =
        submitterId === "Save" ? true : await validateSubmission();
      if (isValid) {
        event.preventDefault();
        const formdata = buildFormDataPayload(dontPublishPro);

        const queryParams = {
          params: { id: user?._id },
          data: formdata,
          headers,
        };

        const isPreviewBtn =
          submitterId === "Preview Profile" ||
          submitterId === "PREVIEW";
        if (isPreviewBtn) {
          formdata.publishProfile = false;
          updateAuthorProfileDetails(queryParams);
          return null;
        }

        if (submitterId !== "Save" && activeTab === "personal") {
          updateAuthorProfileDetails(queryParams);
        } else {
          updateAuthorProfileDetails(queryParams);
        }

        setSaveMyWorkModal(!nomodalopen && dontPublishPro);
        if (!dontPublishPro) {
          // setShowFeedbackModal({
          //   ...initialState,
          //   showFeedbackModal: !profileDetails.feedbackDone,
          //   congratsModal: profileDetails.feedbackDone,
          // });
          navigate("/thanks-for-registration");
        }
      } else {
        toast.error("Please fill in all mandatory fields marked in red.");
        setFocusToTextBox();
      }
    }
  };

  const handleSubmitOutSideIndia = async (
    event,
    dontPublishPro,
    nomodalopen
  ) => {
    const submitterId =
      event?.nativeEvent?.submitter?.id || event?.nativeEvent?.srcElement?.id;
    if (saveStatus && submitterId === "Publish Profile") {
      setShowAccept(true);
    } else {
      event.preventDefault();
      window.scroll({ top: 0, behavior: "smooth" });
      const isValid =
        submitterId === "Save" ? true : await validateSubmission();
      if (isValid) {
        event.preventDefault();
        const formdata = buildFormDataPayload(dontPublishPro);

        const queryParams = {
          params: { id: user?._id },
          data: formdata,
          headers,
        };

        const isPreviewBtn =
          submitterId === "Preview Profile" ||
          submitterId === "Preview Profile";
        if (isPreviewBtn) {
          formdata.publishProfile = false;
          updateAuthorProfileDetails(queryParams);
          return null;
        }

        if (submitterId !== "Save" && activeTab === "personal") {
          updateAuthorProfileDetails(queryParams);
        } else {
          updateAuthorProfileDetails(queryParams);
        }

        setSaveMyWorkModal(!nomodalopen && dontPublishPro);
        if (!dontPublishPro) {
          setShowFeedbackModal({
            ...initialState,
            congratsPreview: true,
          });
        }
      } else {
        toast.error("Please fill in all mandatory fields marked in red.");
        setFocusToTextBox();
      }
    }
  };

  const handlePublishConfirm = () => {
    const queryParams = {
      params: { id: user?._id },
      data: { publishProfile: true, isSetupProfile: true },
      headers,
    };
    updateAuthorProfileDetails(queryParams);
    if (profileDetails?.nationality === "outSideIndia") {
      setShowFeedbackModal({
        ...initialState,
        congratsPreview: true,
      });
    } else {
      navigate("/thanks-for-registration");
    }
  };

  const handleRedirect = (e, path = "/registration") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    localStorage.clear();
    dispatch({ type: "LOGOUT_STATUS_SUCCESS" });
    navigate(path);
  };

  const handleRemoveImageSubmit = () => {
    if (profile === profileDetails.oldProfilePicture) {
      const headers = { Authorization: `Bearer ${userLoginDetails?.token}` };
      removeProfilePic(headers);
      setOpenRemoveImage(false);
    }
    setOpenRemoveImage(false);
    setProfile(null);
  };

  const handleSubmitConfermationModal = () => {
    setOpenConfermationModal(false);
    navigate("/dashboard");
  };

  const handleSaveMyWorkSubmit = (e) => {
    handleSubmit(e, true, "nomodalopen");
    setShowBackMoveModal(false);
    setActiveTab("personal");
  };

  const setAffiliationValidation = (index) => {
    const clonedError = { ...validationError };
    const currentAff = Object.values(clonedError.affiliation)[index];
    if (currentAff) {
      currentAff.url = false;
    }
    setValidationError(clonedError);
  };

  const handleStepClick = async (targetStep) => {
    if (targetStep === "personal") {
      setActiveTab("personal");
      return;
    }

    if (targetStep === "professional") {
      const isPersonalValid = await personalValidation();
      if (!isPersonalValid) {
        setFocusToTextBox();
        return;
      }
      setActiveTab("professional");
      return;
    }

    if (targetStep === "finished") {
      const isPersonalValid = await personalValidation();
      if (!isPersonalValid) {
        setActiveTab("personal");
        setFocusToTextBox();
        return;
      }
      if (activeTab === "professional") {
        const isProfessionalValid = await professionalValidation();
        if (!isProfessionalValid) {
          setFocusToTextBox();
          return;
        }
      }
      navigate("/previewprofile", { state: { profileDetails } });
    }
  };

  const renderCustomStepper = (tab) => {
    const isPersonalComplete =
      profileDetails?.title &&
      profileDetails?.fullName &&
      profileDetails?.gender &&
      profileDetails?.nationality &&
      profileDetails?.journalType &&
      profileDetails?.journalName;

    return (
      <div className={`custom-stepper step-${tab}`}>
        <div className="stepper-track"></div>
        <div
          className={`stepper-step ${tab === "personal" || tab === "professional" ? "active" : ""}`}
          style={{ cursor: "pointer" }}
          onClick={() => handleStepClick("personal")}
        >
          <div className="step-circle">
            <img src={PersonalStepIcon} alt="Personal" style={{ width: "24px", height: "24px" }} />
          </div>
          <div className="step-label">Personal</div>
        </div>
        <div
          className={`stepper-step ${tab === "professional" ? "active" : ""}`}
          style={{ cursor: isPersonalComplete ? "pointer" : "not-allowed", opacity: isPersonalComplete ? 1 : 0.6 }}
          onClick={() => handleStepClick("professional")}
        >
          <div className="step-circle">
            <img src={ProfessionalStepIcon} alt="Professional" style={{ width: "24px", height: "24px" }} />
          </div>
          <div className="step-label">Professional</div>
        </div>
        <div
          className="stepper-step"
          style={{ cursor: isPersonalComplete ? "pointer" : "not-allowed", opacity: isPersonalComplete ? 1 : 0.6 }}
          onClick={() => handleStepClick("finished")}
        >
          <div className="step-circle">
            <img src={FinishedStepIcon} alt="Finished" style={{ width: "20px", height: "20px" }} />
          </div>
          <div className="step-label">Finished</div>
        </div>
      </div>
    );
  };

  const propsCommonTab = [
    {
      eventKey: "personal",
      title: "1. Personal Details",
      propsComponent: (
        <div className="pd-page">
          <div className="pd-card-wrapper">
            <div className="pd-card">
              <div className="pd-card-header">
                <h1>Build Your Profile</h1>
              </div>
              {renderCustomStepper("personal")}
              <PersonalDetailsSection
                handleSelectChange={handleSelectChange}
                validationError={validationError}
                openImageUpload={openImageUpload}
                setOpenImageUpload={setOpenImageUpload}
                profile={profile}
                profileDetails={profileDetails}
                handleUploadImage={handleUploadImage}
                hiddenFileInput={hiddenFileInput}
                handleChangeRadioButton={handleChangeRadioButton}
                handleChange={handleChange}
                handleImageSubmit={handleImageSubmit}
                showDoLatterModal={showDoLatterModal}
                setShowDoLatterModal={setShowDoLatterModal}
                capture={capture}
                phone={phone}
                webcamImage={webcamImage}
                setWebcamImage={setWebcamImage}
                webcamRef={webcamRef}
                openWebcam={openWebcam}
                setOpenWebcam={setOpenWebcam}
                handleWebcam={handleWebcam}
                uploadedImage={uploadedImage}
                setUploadedImage={setUploadedImage}
                handleImageModalClose={handleImageModalClose}
                masterData={masterData}
                handleDoItLatterModal={handleDoItLatterModal}
                buttonBar={SaveContinueBtnFooter}
                setOpenRemoveImage={setOpenRemoveImage}
                openRemoveImage={openRemoveImage}
                handleRemoveImageSubmit={handleRemoveImageSubmit}
                formError={formError}
                setFormError={setFormError}
                removeProfilePic={removeProfilePic}
                journalsList={journalsList}
              />
            </div>
          </div>
        </div>
      ),
    },
    {
      eventKey: "professional",
      title: "2. Professional Details",
      propsComponent: (
        <div className="pd-page">
          <div className="pd-card-wrapper">
            <div className="pd-card">
              <div className="pd-card-header">
                <h1>Profile Details</h1>
              </div>
              {renderCustomStepper("professional")}
              <div className="text-start shadow-box">
                <ProfessionalDetails
                  handleSelectChange={handleSelectChange}
                  handleChange={handleChange}
                  validationError={validationError}
                  handleChangeRadioButton={handleChangeRadioButton}
                  profileDetails={profileDetails}
                  errored={validationError.workType}
                  activeTab={activeTab}
                  masterData={masterData}
                />
                <br />
                {workSection?.map((val, index) => {
                  return (
                    <div key={index} className="col-lg-12">
                      <WorkSection
                        setValidationError={setAffiliationValidation}
                        val={val}
                        errorObj={validationError.affiliation?.[index]}
                        removeField={removeField}
                        ind={index}
                        specializationsData={specializationsData}
                        StateJson={StateJson}
                        otherSpecialization={val.otherSpecialization}
                        handleChange={handleWorkSectionChange}
                        handleSelectChange={handleWorkSelectChange}
                        handleOthers={workSectionOtherSpecialization}
                        handleGetSpecialization={handleGetSpecialization}
                        activeTab={activeTab}
                        heading={val.heading}
                        Sectionindex={index}
                        workSectionValues={val}
                        masterData={masterData}
                        setWorkSection={setWorkSection}
                        workSection={workSection}
                        profileDetails={profileDetails}
                        journalsList={journalsList}
                        renderLinks={index === workSection.length - 1 ? renderLinks : null}
                      />
                    </div>
                  );
                })}
                <div className="col-pd" style={{ display: 'none' }}>
                  <div className="col-lg-12 mb-4">
                    <p>
                      Education{" "}
                      <span className="option-badge mandatory-span badge">
                        Mandatory
                      </span>{" "}
                      <br />
                      <span className="muted-label">Highest degree earned</span>
                    </p>
                  </div>
                </div>
                <EducationSection
                  handleChange={handleEducationChange}
                  handleOthers={handleEducationOtherSpecialization}
                  handleSelectChange={handleEducationSelectChange}
                  handleSubjectId={handleSubjectId}
                  subjectOptions={subjectOptions}
                  profileDetails={profileDetails?.Education}
                  educationSection={educationSection}
                  activeTab={activeTab}
                  errorObj={validationError.educationError}
                  masterData={masterData}
                  specializationsData={specializationsData}
                />
                <div className="pt-0 mb-4 col-lg-12" style={{ display: 'none' }}>
                  <div className="br"></div>
                </div>
                <SubjectOfIntrestSection
                  handleSelectChange={handleSubjectSelectChange}
                  subjectOfIntrestSection={subjectOfIntrestSection}
                  masterData={masterData}
                  errorObj={validationError?.subjectOfIntrestSection}
                  handleOthers={handleSubjectSpecialization}
                  handleSubjectOfIntrestChange={handleSubjectOfIntrestChange}
                  profileDetails={profileDetails}
                  activeTab={activeTab}
                  specializationsData={specializationsData}
                  renderLinks={renderSubjectOfIntrestLinks}
                />
              </div>
              <div className="mt-3 bottomNav">
                {savePreviewPublishBtn}
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  const handleFeedbackModalStat = async (data, refetchData = false) => {
    setShowFeedbackModal(data);
    if (refetchData) {
      const response = await fetchdata();
      setProfileDetails({ ...profileDetails, feedbackDone: refetchData });
      if (response.status === 200) {
        setProfileDetails(response?.data?.data);
      }
    }
  };

  return (
    <div className="centerSection">
      <FeedbackFlow
        handleModalClose={handleFeedbackModalStat}
        modalStat={showFeedbackModal}
        code={profileDetails.promoCode}
      />
      <div className="personal-details">
        <div className="row">
          <div className="col-lg-11 my-3 m-auto">
            <InfoAlert />
            <div className="col-lg-12 col-xl-12 col-md-8 m-auto">
              <Form id="personal_details" onSubmit={(e) => handleSubmit(e)}>
                <div className="label-error text-center">
                  {formError.apiErrors}
                </div>
                <CommonTab
                  propsCommonTab={propsCommonTab}
                  setActiveTab={setActiveTab}
                  activeTab={activeTab}
                  isSection={true}
                  isOnSelect={false}
                  buttonBar={
                    activeTab === "personal"
                      ? SaveContinueBtn
                      : savePreviewPublishBtn
                  }
                  progressBarStatus={
                    activeTab === "personal" ? "20" : servicePercentage
                  }
                />
              </Form>
            </div>
          </div>
        </div>
      </div>

      <UpArrowQuestion
        upArrowButton={activeTab !== "personal" ? true : false}
      />
      {/* <SuccessModal
        label=""
        className="founder-message success-modal"
        show={openConfermationModal}
        LinkTitle="Home"
        LinkPath="/"
        submitButtonTitle={"Start Your Publishing Journey Now"}
        modalHeading="YOU ARE AWESOME!"
        upperInformationText="You have registered and joined"
        lowerInformationText="the mission successfully."
        onSubmit={() => handleSubmitConfermationModal()}
      /> */}

      <Modal
        dialogclassName="modal-dialog-centered modal-md "
        show={openConfermationModal}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal authorModalRed md-x"
      >
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            {" "}
            <img src={alertCheck} alt="#" />
          </div>
          <h5 className="modal-title modal-title-red mt-0">
            You have successfully registered
          </h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={() => {
              setOpenConfermationModal(false);
              navigate("/");
            }}
          ></button>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0">
          <div className="attentionText mw-100">
            <p>
              Thank you for completing the registration. You just joined one of
              the world's fastest growing database of researchers, where
              everyone can support each other's research journey.
            </p>
            <p>
              Please look for the welcome email in your inbox and add us to your
              safe sender's list.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="pb-3">
          <div className="profile-setup-buttons">
            <div className="grp-buttons">
              <button
                className="button button-primary"
                type="button"
                onClick={() => {
                  setOpenConfermationModal(false);
                  setUploadArticle(true);
                }}
              >
                Publish My Article Journey
              </button>
              <Link to="/" className="w-100 mt-3 d-block">
                <img src={AakashgangaHome} alt="AakashgangaIcon" />
              </Link>
            </div>
            <div className="grp-buttons">
              <a
                href="https://vikramshilaedu.in/browse"
                className="button button-primary"
                target="_blank"
              >
                Watch Founder's message
              </a>
              <a
                href="https://www.youtube.com/watch?v=Iewt4-w2R9g"
                className="w-100 mt-3 d-block"
                target="_blank"
              >
                <img src={VikramshilaHome} alt="VikramshilaIcon" />
              </a>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <FormModal
        size="sm"
        show={saveMyWorkModal}
        upperInformationText="Complete your profile to"
        lowerInformationText="<strong>JOIN</strong> the <strong>MOVEMENT</strong>"
        submitButtonTitle="Complete Profile Setup"
        handleClose={() => handleSaveModalClose()}
        onSubmit={() => handleSaveModalClose()}
        closebutton={true}
        className="founder-message success-modal"
        modalHeading="Your work has been saved"
      />

      <FormModal
        size="sm"
        label=""
        modalHeading="Do you want to go back?"
        show={showBackMoveModal}
        closebutton={true}
        upperInformationText="Please save your work before"
        lowerInformationText="going to the previous screen."
        submitButtonTitle={"Save My Work"}
        onSubmit={(e) => handleSaveMyWorkSubmit(e)}
        handleClose={handleCloseModal}
      />

      <BeforePublishModal
        showAccept={showAccept}
        setShowAccept={setShowAccept}
        title={"All Good things take time"}
        body={`<div class="text-center"><p class="font18 allGoodText">Your profile will be published after we approve the subject.</p>
          <p class="mt-3 font18">Thank you for your patience</p>
        </div>`}
        btnTxt={"Okay"}
        onConfirm={handlePublishConfirm}
      />
      <SubmitArticleModal
        uploadArticle={uploadArticle}
        setUploadArticle={setUploadArticle}
      />
    </div>
  );
}

export default PersonalDetails;
